import React, { useEffect, useState, useCallback } from 'react'
import * as actions from '../actions'
import moment from 'moment'
import { connect } from 'react-redux'
import { Col, Row } from 'react-bootstrap'
import { cerealesColor } from '../../../config/cereales'
import TablaCamionesEnCircuito from './camionesEnCircuito/containers/TablaCamionesEnCircuito'
import TablaCamionesEnTransito from './camionesEnTansito/containers/TablaCamionesEnTransito'
import CerealAsignadoAVolcadora from '../../Pesado/components/bruto/CerealAsignadoAVolcadora'
import TablaCamionesConRemito from './camionesConRemito/containers/TablaCamionesConRemito'
import Histogramas from './cdmd/Histogramas'
import { INTERVALO_ACTUALIZACION } from '../../../config/settings'
import TablaDetalleTotalCupo from './totalesCupo/containers/TablaDetalleTotalCupo'
import EstadoPlayaCalado from './camionesCalados/EstadoPlayaCalado'

const CuadroDeMandoComp = (props) => { 
  const [ data, setData ]= useState([])
  const [ init, setInit ] = useState([])
  const [ actualizado, setActualizado ] = useState(false)
  const { 
    ocupacionCalles,
    calificacionCalle, 
    camionesCalados,
    callesDeCalado,
    estadoOcupacionCallesDeCalado,
    callesDeCaladoPorCerealHumedad,
    calificacionCalleDeCalado,
    obtenerCerealAsignadoAVolcadora,
    obtenerCallesVolcadora,
    obtenerCamionesCalados,
    obtenerPosiblesArribos,
    obtenerCodigosDeCupo,
    obtenerConsumidosEnViaje,
    setUltimaActualizacionCDMD,
  } = props


  const actualizarDatos = useCallback(() => {
    setActualizado(false)
    let d = []
    setData(d)

    estadoOcupacionCallesDeCalado()
    callesDeCaladoPorCerealHumedad()
    calificacionCalleDeCalado()
    obtenerCamionesCalados()
    obtenerCerealAsignadoAVolcadora()
    obtenerCallesVolcadora()
    
    const fechaHasta = moment(new Date()).format('YYYY-MM-DD')
    const fechaDesde = moment(fechaHasta).subtract(2, 'days').format('YYYY-MM-DD')
    obtenerPosiblesArribos(fechaDesde, fechaHasta)
    obtenerCodigosDeCupo(fechaDesde, fechaHasta)

    obtenerConsumidosEnViaje()
    setUltimaActualizacionCDMD()
  }, [
    setActualizado,
    setData,
    estadoOcupacionCallesDeCalado,
    callesDeCaladoPorCerealHumedad,
    calificacionCalleDeCalado,
    obtenerCamionesCalados,
    obtenerCerealAsignadoAVolcadora,
    obtenerCallesVolcadora,
    obtenerPosiblesArribos,
    obtenerCodigosDeCupo,
    obtenerConsumidosEnViaje,
    setUltimaActualizacionCDMD
  ])

  useEffect(() => {
    const interval = setInterval(() => {
      setActualizado(false)
      actualizarDatos()
    }, INTERVALO_ACTUALIZACION)

    return () => {
      clearInterval(interval)
    }
  }, [setActualizado, actualizarDatos])

  useEffect(() => {  
    if (init) {
      actualizarDatos() 
      setInit(false)
    }
  },[init, props, setActualizado, setData, actualizarDatos]) 
  
  const generarData = (ocupacionCalles) => {
    let d = []
    setData(d)
    ocupacionCalles && ocupacionCalles.filas.map((calle) => {
      return d.push([
        `C${calle.calleDeCalado}`,
        calle.ocupado,
        (calle.cerealAsignado != null) ? cerealesColor[`${calle.cerealAsignado.trim()}`] : '#e0e0e0',
        `${calle.capacidad}`,
        `${calle.cerealAsignado}`,
        `Calle ${calle.calleDeCalado}-Capacidad ${calle.capacidad}-Usado ${calle.ocupado}-Cereal ${calle.cerealAsignado}`
      ])
    })
    setData(d)
    setActualizado(true)
  }

  const actualizarPlayaCalado = () => {
    setActualizado(false)
    let d = []
    setData(d)
    props.estadoOcupacionCallesDeCalado()
    props.callesDeCaladoPorCerealHumedad()
    props.calificacionCalleDeCalado()
    props.obtenerCamionesCalados()   
  }

  if (ocupacionCalles !== null && ocupacionCalles.filas_procesadas > 0 && data.length === 0) {
    if (ocupacionCalles.estado === 'exito') {
      generarData(ocupacionCalles)
    }
  }

  return (
    <>
      <Row>
        <Col md={8} >
          <Col md={12}  >
            <TablaCamionesEnCircuito />   
          </Col>  
          <Row style={{ margin: '8px auto' }}>
            <Col md={9}>
              <TablaDetalleTotalCupo /> 
            </Col>    
            <Col md={3}>
              {props.volcadorasConCereal && props.calleDeVolcadora
                ? 
                  <div style={{ margin:'14px 0 0 0' }}>
                    <CerealAsignadoAVolcadora
                      volcadorasConCereal={props.volcadorasConCereal}
                      calleDeVolcadora={props.calleDeVolcadora}                      
                    />    
                  </div>                  
                : <></>            
              }
            </Col>           
          </Row>    
         
          <Col md={12} style={{ marginTop: '2%' }}> <Histogramas /> </Col>
         
        </Col>

        <Col md={4}>
          <Col md={12} style={{ margin: '8px auto' }}>        
            <EstadoPlayaCalado
              data={data} 
              setActualizado={setActualizado}
              actualizado={actualizado}
              camionesCalados={camionesCalados} 
              calificacionCalle={calificacionCalle}
              callesDeCalado={callesDeCalado}
              ocupacionCalles={ocupacionCalles}
              actualizarPlayaCalado={actualizarPlayaCalado}
            />
          </Col>
          <Col md={12}>
            <TablaCamionesEnTransito />           
          </Col>     
        </Col>       
      </Row>
      <Row>      
        <Col md={12}>
            <TablaCamionesConRemito />
        </Col>
      </Row>   
    </>
  )
}

const mapStateToProps = (state) => ({
  calificacionCalle: state.calado.calificacionPorCalleCalado,
  calleDeVolcadora: state.volcadora.calleDeVolcadora,
  callesDeCalado: state.calado.callesCaladoPorCerealHum,
  camionesCalados: state.calado.camionesCalados,
  ocupacionCalles: state.calado.estadoOcupacionCallesCalado,
  volcadorasConCereal: state.volcadora.volcadorasConCereal
})

const withRedux = connect(mapStateToProps, actions)
export default withRedux(CuadroDeMandoComp)
